import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

export enum AccountCreationStep {
  AWS_OFFER_WAITING = "awsOfferWaiting",
  USER_ACCOUNT_DETAILS = "userAccountDetails",
  ORGANIZATION_DETAILS = "organizationDetails",
  TERMS_AND_CONDITIONS = "termsAndConditions"
}

export const ACCOUNT_CREATION_STEPS_ORDER: AccountCreationStep[] = [
  AccountCreationStep.AWS_OFFER_WAITING,
  AccountCreationStep.USER_ACCOUNT_DETAILS,
  AccountCreationStep.ORGANIZATION_DETAILS,
  AccountCreationStep.TERMS_AND_CONDITIONS
]

const getStepIndex = (step: AccountCreationStep): number =>
  ACCOUNT_CREATION_STEPS_ORDER.indexOf(step)

interface State {
  onAccountCreationProcess: boolean
  setOnAccountCreationProcess: (onAccountCreationProcess: boolean) => void
  currentStep: AccountCreationStep
  setCurrentStep: (currentStep: AccountCreationStep) => void
  setNextStep: () => void
  setPreviousStep: () => void
  awsMarketplaceToken?: string
  setAwsMarketplaceToken: (awsMarketplaceToken: string) => void
  offerType: api.user.AwsMarketplaceSubscription["offerType"]
  setOfferType: (offerType: api.user.AwsMarketplaceSubscription["offerType"]) => void
}

export const useAccountCreation = create<State>()(
  persist(
    (set, get) => ({
      currentStep: AccountCreationStep.AWS_OFFER_WAITING,
      offerType: "unknown",
      onAccountCreationProcess: false,
      setAwsMarketplaceToken: (awsMarketplaceToken: string) =>
        set({
          awsMarketplaceToken
        }),
      setCurrentStep: (currentStep: AccountCreationStep) =>
        set({
          currentStep
        }),
      setNextStep: () => {
        const currentIndex = getStepIndex(get().currentStep)
        const nextIndex = Math.min(currentIndex + 1, ACCOUNT_CREATION_STEPS_ORDER.length - 1)
        set({ currentStep: ACCOUNT_CREATION_STEPS_ORDER[nextIndex] as AccountCreationStep })
      },
      setOfferType: (offerType: api.user.AwsMarketplaceSubscription["offerType"]) =>
        set({
          offerType
        }),
      setOnAccountCreationProcess: (onAccountCreationProcess: boolean) =>
        set({
          onAccountCreationProcess
        }),
      setPreviousStep: () => {
        const currentIndex = getStepIndex(get().currentStep)
        const previousIndex = Math.max(currentIndex - 1, 0)
        set({ currentStep: ACCOUNT_CREATION_STEPS_ORDER[previousIndex] as AccountCreationStep })
      }
    }),
    {
      name: "AccountCreation",
      storage: createJSONStorage(() => localStorage)
    }
  )
)
